"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabHeader = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.TabHeader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: fit-content(100%) auto;\n  border-bottom: ", ";\n  padding: 0 0.375rem;\n"], ["\n  display: grid;\n  grid-template-columns: fit-content(100%) auto;\n  border-bottom: ", ";\n  padding: 0 0.375rem;\n"])), function (_a) {
    var theme = _a.theme, isInverse = _a.isInverse;
    return isInverse
        ? "0.0625rem solid ".concat((0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["700"]', theme))
        : (0, ui_helper_deep_branding_1.getFromTheme)('LINE.DEFAULT_BORDER', theme);
});
var templateObject_1;
//# sourceMappingURL=tab-header.js.map